import { Link } from 'react-router-dom';
import { FieldLines } from '../components/Field';

export function NotFoundPage({ title = 'Nothing here.', text = 'That page does not exist. It may have been a stale link.' }: { title?: string; text?: string }) {
  return (
    <section className="container pt-4 md:pt-6">
      <div className="relative overflow-hidden bg-blue p-6 text-paper md:p-10">
        <FieldLines />
        <div className="relative">
          <p className="kicker !text-paper/80">Out of bounds</p>
          <h1 className="h1 mt-2">{title}</h1>
          <p className="mt-3 max-w-[46ch] text-[15px] leading-relaxed text-paper/85">{text}</p>
          <div className="mt-6 flex flex-wrap gap-2">
            <Link to="/" className="btn-on-blue">Scoreboard</Link>
            <Link to="/nfl" className="btn border border-paper/50 text-paper hover:bg-paper/15">NFL</Link>
            <Link to="/college" className="btn border border-paper/50 text-paper hover:bg-paper/15">College</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
